import classNames from 'classnames';
import React from 'react';

import { getFormattedDate, getFormattedDateWithName } from '@/utils/date';

import { Typography } from '@/components/atoms/Typography';

interface CodePromotionCardProps {
  active?: boolean;
  offerName: string;
  codePromo?: string;
  endDate: string | Date | null;
  startDate: string | Date;
  numberOfClick?: number;
  circleBgColor?: string;
  containerClassName?: string;
  isSupport?: boolean;
}

export const CodePromotionCard = ({
  active = true,
  offerName,
  codePromo,
  endDate,
  numberOfClick = 0,
  startDate,
  isSupport = false,
  containerClassName,
  circleBgColor = 'bg-white'
}: CodePromotionCardProps) => {
  const isValidDate = (date: any): boolean => {
    return date && !isNaN(new Date(date).getTime());
  };

  return (
    <div
      className={classNames(
        containerClassName,
        'p-5 h-fit shadow-md bg-gradient-to-r hover:contrast-[115%] from-[#EF6193] to-[#693BB7] hover:shadow-md duration-300 rounded-2xl w-full'
      )}
    >
      <div className="flex gap-1 relative flex-col pt-8 justify-center">
        <div className="absolute w-full top-0 flex items-start justify-between">
          <div className="flex items-center gap-1">
            {endDate && new Date(endDate) < new Date() && (
              <div className="bg-red-700/70 border-red-300 border rounded-full w-fit px-4">
                <Typography variant="extraSmall" align="center" color="white">
                  Expiré
                </Typography>
              </div>
            )}

            {active ? (
              <div className="bg-success/80 border-success border rounded-full w-fit px-4">
                <Typography variant="extraSmall" align="center" color="white">
                  Actif
                </Typography>
              </div>
            ) : (
              <div className="bg-red-700/70 border-red-300 border rounded-full w-fit px-4">
                <Typography variant="extraSmall" align="center" color="white">
                  Inactif
                </Typography>
              </div>
            )}
          </div>

          {isSupport && numberOfClick > 0 && (
            <div className="bg-black rounded-md w-fit px-3 py-0.5">
              <Typography variant="extraSmall" align="center" color="white">
                Cliqué {numberOfClick} fois
              </Typography>
            </div>
          )}
        </div>

        <Typography variant="heroTitle" align="center" weight="bold" color="white">
          {offerName}
        </Typography>
        {codePromo && (
          <Typography variant="h2" align="center" color="white">
            via le code "<strong>{codePromo}</strong>"
          </Typography>
        )}
      </div>

      <div className="flex relative">
        <div className={classNames(circleBgColor, 'absolute -right-10 w-8 h-8 rounded-full')} />
        <div className="w-full top-3.5 absolute border-gray-100/40 border border-dashed" />
        <div className={classNames(circleBgColor, 'absolute -left-10 w-8 h-8 rounded-full')} />
      </div>

      <div className="flex flex-col pt-6">
        <Typography variant="h5" color="white">
          Valable {endDate ? 'du' : "jusqu'au"} {isValidDate(startDate) ? getFormattedDateWithName(new Date(startDate)) : 'Date invalide'}
          {endDate && isValidDate(endDate) && ` au ${getFormattedDateWithName(new Date(endDate))}`}
        </Typography>
      </div>
    </div>
  );
};
